import React from "react";

export const VisitorInfoCard = props => (
  <div className="visitor-data">
    <dl className="general-info">
      <dt>visitor name</dt>
      <dd className="body-bold">
        {props.firstName}&nbsp;{props.middleName}&nbsp;{props.lastName}
      </dd>
    </dl>
    <dl className="secondary-info">
      <div>
        <dt>Alias:&nbsp;</dt>
        <dd>{props.otherName}</dd>
      </div>
      <div>
        <dt>ID Type&#47;Number:&nbsp;</dt>
        <dd>
          {props.applicantIdType}&#47;{props.applicantIdNumber}
        </dd>
      </div>
      <div>
        <dt>Last 4 of SSN:&nbsp;</dt>
        <dd>{props.applicantSsn}</dd>
      </div>
      <div>
        <dt>Physical Description:&nbsp;</dt>
        <dd>
          {props.applicantRace},&nbsp;
          {props.applicantSex},&nbsp;
          {props.applicantHeightFt}'{props.applicantHeightIn}",&nbsp;
          {props.applicantHair}&nbsp;Hair,&nbsp;
          {props.applicantEyes}&nbsp;Eyes,&nbsp;
          {props.applicantWeight} lbs.
        </dd>
      </div>
    </dl>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/VisitorInfoCard/VisitorInfoCard.js